import React, { useEffect } from 'react';
import { Util, Request, Principal, Scroller, StateProvider, ProxyProvider, childrenText, BAProvider } from '../common';
import { InputAdornment, CircularProgress, IconButton, FormControl, InputLabel, FormHelperText } from '@material-ui/core';
import { Scrollbars } from 'react-custom-scrollbars';
import { HelpLink } from './Button';
import Tooltip from './Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

export function parseHelp(arg) {  //解析帮助文档的参数
  if (Util.type(arg) === "string") {
    if (arg.startsWith("http://") || arg.startsWith("https://")) {
      return { url: arg };
    }
    return { message: arg };
  }
  return arg || {};
}

export function getHelpIcon(help,linkProps) {
  let {url,message}=parseHelp(help);
  linkProps = linkProps ||{};
  let {className,textClassName} = linkProps;
  if(url || message)
    return <HelpLink size="md"tip={message} href={url} {...linkProps} className={`${url?'':"c-text-grey"} ${className||''}`}  textClassName={`${url?'':"c-text-grey"} ${textClassName||''}`} />;
}